const styles = () => `
        .site-header, 
        .site-footer {
            display: none;
        }

        .hkb-breadcrumbs li:first-child {
            display: none;
        }

        #hkb.hkb-searchresults > li a[href^="https://kundservice.dabas.com/knowledge-base/logga-in-forsta-gangen-pa-delfis-nya-plattform/"],
        #hkb.hkb-searchresults > li a[href^="https://kundservice.dabas.com/knowledge-base/kom-igang-med-statistik-i-delfi-plattformen/"],
        #hkb.hkb-searchresults > li a[href^="https://kundservice.dabas.com/knowledge-base/delfi-next/"], 
        #hkb.hkb-searchresults > li a[href^="https://kundservice.dabas.com/knowledge-base/manual-saljdistriktplanering/"],
        #hkb.hkb-searchresults > li a[href^="https://kundservice.dabas.com/knowledge-base/delfi-api-kom-igang/"],
        .ht-articlelist a[href^="https://kundservice.dabas.com/knowledge-base/logga-in-forsta-gangen-pa-delfis-nya-plattform/"],
        .ht-articlelist a[href^="https://kundservice.dabas.com/knowledge-base/kom-igang-med-statistik-i-delfi-plattformen/"],
        .ht-articlelist a[href^="https://kundservice.dabas.com/knowledge-base/delfi-next/"], 
        .ht-articlelist a[href^="https://kundservice.dabas.com/knowledge-base/manual-saljdistriktplanering/"],
        .ht-articlelist a[href^="https://kundservice.dabas.com/knowledge-base/delfi-api-kom-igang/"] {
            display: none;
        }

        .ht-articlelist li {
            border-bottom: none;
            margin: 0;
            padding: 0;
        }

        .hkb-articlemini {
            display: block;
            margin-bottom: 0;
            border-radius: 0;
            background:transparent;
            padding: 0;
        }

        .hkb-articlemini > a {
            display: block;
            margin-bottom: 20px;
            border-radius: 5px;
            background: #f4f5f5;
            padding: 20px;
        }

        
`;

export default styles;